import {InteractionRequiredAuthError} from "@azure/msal-browser";

import {msalInstance} from "./msalInstance.ts";
import {backendRequest} from "./msalConfig.ts";



export async function getAccessToken(): Promise<string> {
    if ((msalInstance as any).initialize) {
        await (msalInstance as any).initialize();
    }

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) throw new Error("No signed-in account found");

    let activeAccount = msalInstance.getActiveAccount();
    if (!activeAccount) {
        activeAccount = accounts[0];
        msalInstance.setActiveAccount(activeAccount);
    }

    try {
        const result = await msalInstance.acquireTokenSilent({
            ...backendRequest,
            account: activeAccount,
        });

        return result.accessToken;
    } catch (error) {
        // Re-authenticate interactively instead of dropping the session.
        if (error instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect({
                ...backendRequest,
                account: activeAccount,
            });
        }

        throw error;
    }
}
